import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const MostPopularPostsWrapper = styled.div`
  @media (${mediaQuery.tablet}) {
    padding: 0 16px;
  }
`;

export const MostPopularPostsTitleWrapper = styled.h2`
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #333f48;
  margin-bottom: 16px;
  @media (${mediaQuery.tablet}) {
    font-size: 20px;
    line-height: 26px;
  }
`;
